import React from "react";
import { useRef } from "react";
import { useIntersectionObserver } from "../../hooks/useIntersectionObserver";

const FadeInSection = ({ children, threshold = 0.1 }) => {
  const ref = useRef(null);
  const isVisible = useIntersectionObserver(ref, { threshold });

  return (
    <div
      ref={ref}
      style={{
        transition: "all 1s",
        opacity: isVisible ? 1 : 0,
      }}
    >
      {children}
    </div>
  );
};

export default FadeInSection;
